class bookingUpdateController {
	/**
	 *
	 * @param $bookings
	 */
	constructor($injector, $bookings, $rootScope, $uibModal) {

		'ngInject';

		this.$bookings = $bookings;
		this.$rootScope = $rootScope;
		this.$uibModal = $uibModal;
		this.booking = Object.assign({}, this.resolve.items.booking);
		this.isAdmin = this.resolve.items.isAdmin;
		this.notify   = $injector.get('ngNotify');

		this.routes = $bookings.collections.routes.filter(route => route.operator === this.booking.route_operator);
		this.vehicleBodies = $bookings.collections.vehicleBodies;

		this.ETVehicleWidth = [
      { value: 7.49, label: 'Poniżej 7,5m' },
      { value: 13, label: 'Pomiędzy 7,5 a 13m' },
      { value: 19, label: 'Powyżej 13m' },
    ];

    this.tunnelVehicleWidth = [
      { value: 10, label: 'Do 10 m' },
      { value: 18.75, label: 'Do 18,75 m'},
    ];

    if (['EUROTUN', 'EUROTUN_CZ'].includes(this.booking.route_operator)) {
			this.booking.vehicle_length = this.ETVehicleWidth.find(i => i.value === this.booking.vehicle_length);
		} else if (['MONTBLANC', 'MONTBLANC_CZ', 'FREJUS', 'FREJUS_CZ'].includes(this.booking.route_operator)) {
      this.booking.vehicle_length = this.tunnelVehicleWidth.find(i => i.value === this.booking.vehicle_length)
    }

		this.booking.departure_hours = window.moment(this.booking.departure_date).format('HH:mm');

	}

	setDefaultRelation() {
		this.booking.route = this.routes.filter(route => route.uri === this.booking.route)[0];
	}

	onRelationChange() {
		this.setDefaultVehicleType();
		if (this.booking.route.route_operator === 'POLSCA_EMAIL') {
			this.booking.departure_hours = '';
		}
	}

	setDefaultVehicleType() {
		try {
			this.booking.vehicle_type = this.vehicleBodies[this.booking.route.operator]
				.filter(body => body.name === this.booking.vehicle_type)[0];
		} catch (e) {
			this.booking.vehicle_type = "undefined";
		}

		if (typeof this.booking.vehicle_type === "undefined") {

			let firstBody = this.vehicleBodies[this.booking.route.operator][0];

			this.booking.vehicle_type = firstBody;
			this.booking.vehicle_length = firstBody.length;
			this.booking.weight = firstBody.weight;

		}

	}

	resetDefaultValues() {
		try {
			this.booking.route = String(this.booking.route.uri);
			this.booking.vehicle_type = String(this.booking.vehicle_type.name);
			if (typeof this.booking.vehicle_length === 'object') {
				this.booking.vehicle_length = this.booking.vehicle_length.value;
			}
		} catch (e) {
		}
	}

	$onInit() {
		this.setDefaultRelation();
		this.setDefaultVehicleType();
		this.empty = false;
		this.old_actual_booking_value = angular.copy(this.booking.actual_booking_value);
		this.uploadUri = this.booking.uris.BookingFiles;

	}

	isAfterhoursForPolsca() {
		const hour = parseInt(new Intl.DateTimeFormat('pl', {
			timeZone: 'Europe/Warsaw',
			hour: 'numeric',
			hour12: false
		}).format(new Date()), 10);
		return hour >= 22 || hour < 8;
	}

	showAfterhoursNote() {
		this.$uibModal.open({
			component: 'afterhours',
			windowClass: 'center-modal',
		});
	}

	$onSubmit(formBookingUpdate, $event) {
		if (this.booking.route_operator === 'POLSCA_EMAIL' && this.isAfterhoursForPolsca()) {
			formBookingUpdate.$submitted = false;
			this.showAfterhoursNote();
			return;
		}

		if (this.showHours) {
			let departureDate = window.moment(this.booking.departure_date);
			const timeParts = this.booking.departure_hours.split(':');
			departureDate.hours(timeParts[0]).minutes(timeParts[1]);
			this.booking.departure_date = departureDate.format();
		}
		this.booking = this.$bookings.updateTallinkData(this.booking);

		this.resetDefaultValues();
		if (this.empty) {
      this.booking.weight = 0;
    }
		this.booking.booking_status = 5;

		this.$bookings.update(this.booking)
			.then(booking => this.booking = booking)
			.then(() => {
				this.$rootScope.$emit('bookingLimitComponentUpdateValue', {
						method: "update",
						actual_booking_value: this.old_actual_booking_value - this.booking.actual_booking_value
					}
				)
			})
			.then(() => this.$onClose($event))
			.then(() => formBookingUpdate.$submitted = false)
		  .catch(response => {
				console.log(response);
				this.notify.set(response.data.reason || 'Coś poszło nie tak', 'error')
				formBookingUpdate.$submitted = false
			});
	}

	$onClose($event) {
		$event.preventDefault();
		this.resetDefaultValues();
		this.close({$value: 'cancel'});
	}

	$onSetTime() {
		$('[data-toggle="dropdown"]').parent().removeClass('open');
		this.booking.departure_hours = '';
	}

	$is_booking_value_override(click) {
		if (!click) {
			return this.is_booking_value_override = this.booking.booking_value_override !== null;
		}
		if (!this.is_booking_value_override) {
			this.booking.booking_value_override = null;
		}
	}

	get selectedVehicleBody() {
    if (this.booking && this.booking.route && this.booking.route.operator && this.booking.vehicle_type) {
      return this.vehicleBodies[this.booking.route.operator].find(vb => vb.id === this.booking.vehicle_type.id);
    } else {
      return null;
    }
  }

  get vbLengthRange() {
    const vb = this.selectedVehicleBody;
    return {
      min: vb && vb.minLength || 0,
      max: vb && vb.maxLength || 22
    }
  }

	get showHours() {
    return this.booking && this.booking.route && this.booking.route.schedule && !this.booking.route.silent_schedule;
  }

  onVehicleBodyChange() {
    const vb = this.selectedVehicleBody;
    this.booking.vehicle_length = vb.length || vb.minLength;
    this.booking.weight = vb.weight;
  }

	beforeRender ($view, $dates) {
    const minDate = window.moment().startOf($view).valueOf(),
          maxDate = window.moment().add(14, 'days').startOf($view).valueOf();
    angular.forEach($dates, function(date) {
        const localDateValue = date.localDateValue();
        date.selectable = localDateValue >= minDate && localDateValue <= maxDate;
    });
  };

}

export default bookingUpdateController;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-update/booking-update.controller.js
 **/